import {Injectable} from '@angular/core';
import { API } from '../constants/api.constants';
import { Http, Headers } from '@angular/http';
import { NavigationStart, Router } from '@angular/router';
import {CONFIG} from './../../shared/constants/config.constants';

@Injectable()
export class SaveAuditService {

    private resourceUrlSaveAudit = API.host + 'systemLogs/save-audit';
    private delaySaveLogMilisecond = 1000;
    private lastTimeCallAPI: any = new Date(0);

    constructor(
        private http: Http,
        private router: Router,
    ) {}

    saveAudit(req?: any, notLock = false) {
        let userInfo = JSON.parse(sessionStorage.getItem('login'));
        if (!userInfo) {
            return;
        }

        let time: any = new Date();
        if (time - this.lastTimeCallAPI > this.delaySaveLogMilisecond || notLock) {
            if (!notLock) {
                this.lastTimeCallAPI = time;
            }
            var header = new Headers();
            header.append('X-Authorization-Token', userInfo.userId);
            this.http
                .post(`${this.resourceUrlSaveAudit}`, req, {
                    headers: header
                })
                .map((res: any) => {
                    if (!res || !res.json) {
                        throw 'Invalid Code';
                    }
                    return res.json().data;
                }).subscribe();
        }
    }

    saveAuditLog() {
        const mapping = CONFIG.mappingUrl;
        const screenUrls = mapping.map(x => x.id);
        let url = this.router.url;
        if ((screenUrls as any).includes(url)) {
            let logInfo = mapping.find(x => x.id === url);
            const menu_ = logInfo.name;
            this.saveAudit({
                functionCode : logInfo.value,
                logSummary: 'Portal ' + menu_,
                logDetail: 'Truy cập menu ' + menu_,
            });
        }
    }

    registerAndSaveAuditLog() {
        this.saveAuditLog();
        const mapping = CONFIG.mappingUrl;
        const screenUrls = mapping.map(x => x.id);
        var infoLogin = JSON.parse(sessionStorage.getItem("login"));
        if(infoLogin){
            this.router.events.filter((event: any) => event instanceof NavigationStart)
                .subscribe((event: NavigationStart) => {
                    // const screenUrl = this.$localStorage.retrieve('screenUrlAuditLog');
                    
                        if ((screenUrls as any).includes(event.url)) {
                            let logInfo = mapping.find(x => x.id === event.url);
                            const menu_ = logInfo.name;
                            this.saveAudit({
                                functionCode : logInfo.value,
                                logSummary: 'Portal ' + menu_,
                                logDetail: 'Truy cập menu ' + menu_,
                                userId: infoLogin.userId,
                            });
                        }
    
                })
        }
    }
}
